import React from 'react';
import { AlertCircle, X, ExternalLink } from 'lucide-react';

const MigrationBanner = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  const handleRedirect = () => {
    window.location.href = 'https://cova.cliffmutinda.com';
  };

  return (
    <div 
      className="alert alert-warning border-0 rounded-0 m-0 py-2 px-3 shadow-sm"
      role="alert"
      style={{
        backgroundColor: '#fffbeb',
        borderBottom: '1px solid rgba(217, 119, 6, 0.15)',
        zIndex: 1040,
        position: 'relative'
      }}
    >
      <div className="container-fluid d-flex flex-column flex-sm-row align-items-center justify-content-between gap-2 gap-sm-0">
        
        {/* Message area */}
        <div className="d-flex align-items-center gap-2 flex-wrap justify-content-center text-center text-sm-start">
          <AlertCircle size={18} style={{ color: '#d97706' }} className="flex-shrink-0" />
          <span className="fw-medium" style={{ fontSize: '14px', color: '#78350f' }}>
            COVA has moved to a new domain:{' '}
            <strong style={{ color: '#451a03' }}>cova.cliffmutinda.com</strong>
          </span>
        </div>
        
        {/* Action button & Close icon */}
        <div className="d-flex align-items-center gap-3">
          <button
            type="button"
            className="btn btn-sm fw-semibold d-flex align-items-center gap-1 py-1 px-3 text-white"
            onClick={handleRedirect}
            aria-label="Visit the new COVA website"
            style={{
              backgroundColor: '#d97706',
              border: 'none',
              borderRadius: '6px',
              fontSize: '12.5px',
              transition: 'background-color 0.1s ease'
            }}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#b45309'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#d97706'}
          >
            <span>Visit New Site</span>
            <ExternalLink size={13} />
          </button>
          
          <button
            type="button"
            className="btn p-1 d-flex align-items-center justify-content-center border-0"
            onClick={onClose}
            aria-label="Dismiss persistent migration banner"
            style={{ 
              borderRadius: '4px',
              color: '#d97706',
              opacity: 0.7,
              transition: 'opacity 0.1s ease',
              backgroundColor: 'transparent'
            }}
            onMouseOver={(e) => e.currentTarget.style.opacity = 1}
            onMouseOut={(e) => e.currentTarget.style.opacity = 0.7}
          >
            <X size={16} />
          </button>
        </div>
        
      </div>
    </div>
  );
};

export default MigrationBanner;
